import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { Loader, SpacerVertical } from '@klarna/bubble-ui';
import { Column } from 'moet-core';
import { components as clientComponents } from 'mage-client';
import { components as coreComponents } from 'mage-core';
import { CAPS } from '@/constants';
import { getBpcPayload, getContractRegion } from '@/selectors/bpc';
import { isFetchingBpc as isFetchingBpcSelector } from '@/selectors/loadingStates';
import { getDecodedWidgetToken } from '@/utils/widget';
import { OnboardingComponent } from './components/BaseComponents/OnboardingComponent';
const _BpcApp = ({ contractKrn, payload, associateUserToContract, fetchOnboarding, initiateUnderwriting, patchOnboarding, submitTermsAndConditions, }) => {
    // On the initial render we associate the user Id to the contract and fetch the BPC data
    useEffect(() => {
        associateUserToContract();
        if (payload == null) {
            fetchOnboarding();
        }
    }, []);
    if (contractKrn == null || payload == null) {
        return (
        // @ts-expect-error: FIXME
        React.createElement(Column, { alignItems: "center" },
            React.createElement(SpacerVertical, { extraExtraLarge: true }),
            React.createElement(Loader, null)));
    }
    return (React.createElement(OnboardingComponent, { onboardingKrn: contractKrn, initialPayload: payload, fetchOnboarding: fetchOnboarding, patchOnboarding: patchOnboarding, initiateUnderwriting: initiateUnderwriting, submitTermsAndConditions: submitTermsAndConditions }));
};
export const BpcApp = compose(coreComponents.withTokenHelper(
// @ts-expect-error: FIXME
(tokenHelper) => ({
    userId: tokenHelper.getUserId(),
    userEmail: tokenHelper.getUsername(),
})), connect((state) => {
    var _a;
    return ({
        contractKrn: (_a = getDecodedWidgetToken()) === null || _a === void 0 ? void 0 : _a.contractKrn,
        payload: getBpcPayload(state),
        region: getContractRegion(state),
        isFetchingBpc: isFetchingBpcSelector(state),
    });
}), 
// @ts-expect-error: FIXME
clientComponents.withPromiseBasedCapabilities({
    associateUserToContractCap: CAPS.BPC_ASSOCIATE_USER,
    fetchOnboardingCap: CAPS.BPC_GET,
    initiateUnderwritingCap: CAPS.BPC_INITIATE_UNDERWRITING,
    patchOnboardingCap: CAPS.BPC_PATCH,
    submitTermsAndConditionsCap: CAPS.BPC_SUBMIT_TERMS_AND_CONDITIONS,
}), withHandlers({
    associateUserToContract: ({ associateUserToContractCap, contractKrn = '', region, userId, userEmail, }) => () => userId && userEmail
        ? associateUserToContractCap({
            body: { user_id: userId, email: userEmail },
            params: { contractKrn },
            region,
        })
        : Promise.resolve(),
    fetchOnboarding: ({ contractKrn, isFetchingBpc, fetchOnboardingCap, region }) => () => !isFetchingBpc
        ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            fetchOnboardingCap({ params: { contractKrn: contractKrn }, region })
        : Promise.resolve(),
    initiateUnderwriting: ({ initiateUnderwritingCap, region, contractKrn }) => () => 
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    initiateUnderwritingCap({ params: { contractKrn: contractKrn }, region }),
    patchOnboarding: ({ patchOnboardingCap, region, contractKrn }) => (payload) => 
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    patchOnboardingCap({ body: payload, params: { contractKrn: contractKrn }, region }),
    submitTermsAndConditions: ({ submitTermsAndConditionsCap, contractKrn, region }) => (payload) => 
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    submitTermsAndConditionsCap({ body: payload, params: { contractKrn: contractKrn }, region }),
}))(_BpcApp);
